import React, {
    useState
} from 'react';


import {
    useCurationConfigState
} from '../../../hooks/widgetConfiguration.js';

import {
    RIQPopover
} from '../../../components/RIQPopover.jsx';

const searchTips = (<div className='tlw-max-w-[338px] tlw-rounded-md tlw-bg-white tlw-p-10 tlw-shadow-md'>
    <p className='tlw-mb-1 tlw-font-bold'>Match any keyword</p>
    <p className='tlw-mb-4'>Use OR in all caps.<br />Example, <code>Giveaway OR sale</code> will match posts with either keyword.</p>

    <p className='tlw-mb-1 tlw-font-bold'>Match two or more keywords</p>
    <p className='tlw-mb-4'>Use AND in all caps.<br />Example, <code>Facebook AND Instagram</code> will match posts with both keywords.</p>

    <p className='tlw-mb-1 tlw-font-bold'>Match variations of a keyword</p>
    <p className='tlw-mb-4'>Use * to match any character.<br />Example, <code>market*</code> will match marketing and marketer.</p>

    <p className='tlw-mb-1 tlw-font-bold'>Exclude keywords from search</p>
    <p className='tlw-mb-4'>Use NOT in all caps before the keyword.<br />Example, <code>NOT comment</code></p>

    <p className='tlw-mb-1 tlw-font-bold'>Search for hashtags</p>
    <p>Simply type in the hashtag.<br />Example, <code>#social</code></p>
    <a
        className='tlw-text-md tlw-text-blue-400 hover_tlw-underline'
        href='http://help.rivaliq.com/user-guides/social-post-search-tips'
        rel='noopener noreferrer'
        target='_blank'
    >
View more search tips <i className='fa fa-external-link'></i>
    </a>
</div>);


export default function SearchBar({searchTermCurationStateKey = 'searchTerm', postsCount}) {

    const [searchTerm, setSearchTerm] = useCurationConfigState(searchTermCurationStateKey);
    const [uncommittedSearchTerm, setUncommittedSearchTerm] = useState(searchTerm);

    function onChange(event) {
        setUncommittedSearchTerm(event.target.value);
    }

    function onClick() {
        setSearchTerm(uncommittedSearchTerm);
    }

    return (
        <div className='tlw-flex tlw-w-full tlw-flex-col sm_tlw-w-auto'>
            <div className='tlw-relative tlw-w-full'>
                <input
                    className='tlw-h-17 tlw-w-full tlw-min-w-[288px] tlw-rounded-sm tlw-border tlw-border-solid tlw-border-gray-600 tlw-bg-white tlw-px-6 tlw-py-1.5 tlw-text-left tlw-text-gray-900 tlw-placeholder-gray-625 tlw-shadow-sm focus_tlw-border-blue-400 focus_tlw-outline-none focus_tlw-ring-4 focus_tlw-ring-blue-400 focus_tlw-ring-opacity-50'
                    onChange={onChange}
                    placeholder='Search Post Content'
                    value={uncommittedSearchTerm}
                />
                <button
                    id='search-button'
                    className='tlw-absolute tlw-right-0 tlw-top-0 tlw-flex tlw-h-full tlw-min-w-18 tlw-items-center tlw-justify-center tlw-border-none tlw-bg-transparent tlw-p-0 tlw-text-gray-625 hover_tlw-text-blue-400'
                    onClick={onClick}
                >
                    <span className='fa fa-search' />
                </button>
            </div>
            <div className='tlw-mt-2 tlw-flex tlw-items-center tlw-justify-between'>
                <div className='tlw-text-sm tlw-text-gray-800'>
                    {postsCount ? `Analyzing ${RivalIQ.formatter.formatAbbreviated(postsCount)} Posts` : `No Results Found`}
                </div>
                <RIQPopover
                    placement={'bottom'}
                    triggerNode={ <span
                        className='tlw-text-sm tlw-text-blue-400 hover_tlw-underline'
                    >
                        Search tips
                    </span>}
                >{searchTips}</RIQPopover>
            </div>
        </div>
    );
}
